import axios from "axios";

const apiBolsa = axios.create({
  baseURL: process.env.REACT_APP_WLBE_XP_BOLSA || "http://localhost:8888",
});

export default apiBolsa;
